import { useToast, useTranslations } from "@jugl-web/utils";
import { InvoiceModel, InvoiceType } from "@jugl-web/rest-api";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { invoicesApi } from "@web-src/features/api/createApi";

export const useChangeInvoiceType = () => {
  const { t } = useTranslations();
  const { entityId } = useEntitySelectedProvider();
  const [createInvoiceFromExisting] =
    invoicesApi.useCreateInvoiceFromExistingMutation();
  const { toast } = useToast();

  return async (
    convertType:
      | "convert-to-proforma"
      | "convert-to-invoice"
      | "convert-to-purchase-order",
    itemId: string
  ): Promise<InvoiceModel> => {
    const targetType: InvoiceType =
      convertType === "convert-to-proforma"
        ? "proforma"
        : convertType === "convert-to-invoice"
          ? "invoice"
          : "purchase_order";

    const newInvoice = await createInvoiceFromExisting({
      entityId,
      existingInvoiceId: itemId,
      payload: { type: targetType },
    }).unwrap();

    toast(
      t({
        defaultMessage: "Document was successfully converted",
        id: "invoices.document-converted-successfully",
      }),
      {
        variant: "success",
      }
    );

    return newInvoice;
  };
};
